// Action constants
import {SET} from './constants';

const DEFAULT_STATE = {
  numberOfTolls: 0,
};

export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET: {
      return {
        ...state,
        ...data,
        inited: true,
      };
    }

    default: {
      return state;
    }
  }
};
